import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const FranchisesList = () => {
    // State for franchises and filtered franchises
    const [franchises, setFranchises] = useState([]);
    const [filteredFranchises, setFilteredFranchises] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Fetch franchises when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}franchises`)
            .then(response => response.json())
            .then(data => {
                setFranchises(data);
                setFilteredFranchises(data); // Set initial filtered franchises
            })
            .catch(error => console.error('Error fetching franchises:', error));
    }, []);

    // Handle search term change
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        // Filter franchises based on the search term
        const filtered = franchises.filter(franchise =>
            franchise.name.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredFranchises(filtered);
    };

    // Navigate to the edit franchise page
    const handleEdit = (id) => {
        navigate(`/EditFranchise/${id}`);
    };

    // Navigate to the add franchise page
    const handleAdd = () => {
        navigate('/AddFranchise');
    };

    // Handle franchise deletion
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this franchise?")) {
            fetch(`${BASE_URL}franchises/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        // Remove the deleted franchise from both lists (franchises and filteredFranchises)
                        setFranchises(franchises.filter(franchise => franchise.id !== id));
                        setFilteredFranchises(filteredFranchises.filter(franchise => franchise.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting franchise:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Franchise List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Basic Tables start */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add Franchise</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="searchTerm" className="form-label">Search by Name</label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search franchise name"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>NAME</th>
                                                <th>EMAIL</th>
                                                <th>LOCATION</th>
                                                <th>CITY</th>
                                                <th className="text-end">ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredFranchises.map(franchise => (
                                                <tr key={franchise.id}>
                                                    <td>{franchise.name || 'N/A'}</td>
                                                    <td>{franchise.email || 'N/A'}</td>
                                                    <td>{franchise.location || 'N/A'}</td>
                                                    <td>{franchise.city || 'N/A'}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(franchise.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(franchise.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Basic Tables end */}
        </div>
    );
};

export default FranchisesList;
